/**
 * 체험하기(exhibition/play) 페이지용 정적 문항·캐릭터·역량 매핑 데이터.
 * 무인증 체험 화면(pages/play.tsx, pages/play1.tsx)에서 사용한다.
 * CMS가 없어 코드에 하드코딩되어 있다.
 */
export const EXHIBITION_QUESTIONS = [
    {
        id: 1,
        content: "같은 조 친구가 발표 자료 만들기를 맡았는데, 약속한 날짜까지 못 끝내서 전체가 늦어지고 있는 상황이야. 팀장인 내가 먼저 할 일은?",
        options: [
            { id: 101, text: "친구의 사정을 먼저 듣는 것이 우선이다.", competency: "W", skill: "Empathy/active listening" },
            { id: 102, text: "남은 일을 마무리하는 것이 우선이다.", competency: "M", skill: "Talent management" },
            { id: 103, text: "팀 분위기를 다잡는 것이 우선이다.", competency: "E", skill: "Global citizenship" },
        ],
    },
    {
        id: 2,
        content: "발표가 가까워지자 모두가 지쳐서 \"그냥 대충 하자\"는 분위기야. 팀장인 나의 속마음은?",
        options: [
            { id: 201, text: "“그래도 내가 팀장이니 포기하지말고 끝까지 열심히 해보자.”", competency: "S", skill: "Motivation/self-awareness" },
            { id: 202, text: "“무슨 말을 해줘야 친구들이 다시 힘을 낼까?”", competency: "W", skill: "Leadership/social influence" },
            { id: 203, text: "\"친구들이 일을 좀 더 쉽게 할 수 있는 프로그램이 뭐가 있을까?\"", competency: "T", skill: "Technology literacy" },
        ],
    },
    {
        id: 3,
        content: "올해 우리 반 학교 축제 부스 컨셉을 정해야 해. 내가 가장 마음에 드는 방법은?",
        options: [
            { id: 301, text: "작년에 인기 많았던 부스들의 좋은 점을 가져와서 분석해본다.", competency: "C", skill: "Analytical thinking" },
            { id: 302, text: "사람들의 눈길을 끄는 부스 컨셉으로 우리가 직접 만들어본다.", competency: "T", skill: "Design/UX" },
            { id: 303, text: "친구들 의견을 다 들어본 뒤, 투표를 통해 결정한다.", competency: "W", skill: "Leadership/social influence" },
        ],
    },
    {
        id: 4,
        content: "올해 부스 컨셉을 '방탈출 게임'로 하기로 정했어. 부스에서 가장 하고 싶은 역할은?",
        options: [
            { id: 401, text: "나만의 아이디어로 방탈출 공간을 꾸미는 인테리어 담당", competency: "C", skill: "Creative thinking" },
            { id: 402, text: "방탈출 문제를 만들고 계속 개선해나가는 문제 출제 담당", competency: "S", skill: "Resilience" },
            { id: 403, text: "손님을 맞이하고 방탈출을 재밌게 즐기도록 지원하는 안내 담당", competency: "E", skill: "Service orientation" },
        ],
    },
    {
        id: 5,
        content: "만약 다이어트를 결심했다면, 성공하기 위해 가장 중요하다고 생각하는 것은?",
        options: [
            { id: 501, text: "포기하지 않고 꾸준히 밀고 나가는 마음가짐", competency: "S", skill: "Resilience" },
            { id: 502, text: "철저한 식단과 운동 계획", competency: "M", skill: "Resource management" },
            { id: 503, text: "매일 사진으로 변화를 기록하고 남기는 것", competency: "E", skill: "Marketing/media" },
        ],
    },
    {
        id: 6,
        content: "다이어트를 한 달 동안 열심히 했는데 결과가 생각보다 안 나와서 속상해. 지금 가장 듣고 싶은 말은?",
        options: [
            { id: 601, text: "\"괜찮아. 포기만 하지 않으면 반드시 좋은 결과를 얻을 수 있어.\"", competency: "S", skill: "Motivation/self-awareness" },
            { id: 602, text: "\"고생했어. 한 달 동안 진행한 식단과 운동량 데이터부터 모아보자.\"", competency: "T", skill: "AI/big data" },
            { id: 603, text: "\"수고 많았어. 다이어트할 때 미처 놓친 부분이 있었는지 같이 분석해보자.\"", competency: "C", skill: "Analytical thinking" },
        ],
    },
    {
        id: 7,
        content: "우리 반 유튜브 채널을 만들기로 했어. 유튜브를 운영하면서 어떤 역할을 맡고 싶어?",
        options: [
            { id: 701, text: "유튜브 채널을 관리하는 PD를 맡는다.", competency: "M", skill: "Resource management" },
            { id: 702, text: "참신한 컨텐츠 내용을 만드는 기획자를 맡는다.", competency: "C", skill: "Creative thinking" },
            { id: 703, text: "영상의 완성도를 높이는 편집자를 맡는다.", competency: "S", skill: "Resilience" },
        ],
    },
    {
        id: 8,
        content: "연습 촬영 중 친구의 연기가 너무 어색해서 NG가 계속 나. 친구는 연기가 생각보다 어렵고 힘들대. 너가 촬영 감독이라면 어떻게 해야할까?",
        options: [
            { id: 801, text: "친구의 상황을 고려해 팀원들의 역할을 다시 나눠서 진행한다.", competency: "M", skill: "Talent management" },
            { id: 802, text: "직접 시범을 보여주면서 친구 옆에서 긴장을 풀어준다.", competency: "W", skill: "Empathy/active listening" },
            { id: 803, text: "'생생한 첫 촬영 분위기' 컨셉을 추가하여 오히려 재밌게 살린다.", competency: "E", skill: "Marketing/media" },
        ],
    },
    {
        id: 9,
        content: "학교 근처 하천이 너무 더러워서 친구들과 함께 오염 지역 조사 활동을 했을 때, 가장 기분이 좋을 것 같은 일은?",
        options: [
            { id: 901, text: "SNS에 올린 활동 영상이 유명해져서 사람들의 관심과 응원이 쏟아진다.", competency: "E", skill: "Marketing/media" },
            { id: 902, text: "드론으로 찍은 오염지역 영상이 대기업에 전달되어 기업 연계 프로젝트와 탐방 기회가 생긴다.", competency: "T", skill: "Technical Literacy" },
            { id: 903, text: "봉사 동아리 활동의 공로를 인정받아, 동아리 대표로서 교육청 표창을 받는다.", competency: "W", skill: "Leadership/social influence" },
        ],
    },
    {
        id: 10,
        content: "다른 학교 친구들도 동아리에 들어오면서 운영진을 뽑게 됐어. 회장인 내가 가장 중요하게 볼 점은?",
        options: [
            { id: 1001, text: "새로 온 회원이 편안하게 적응하도록 돕는 사람인가", competency: "E", skill: "Service orientation" },
            { id: 1002, text: "동아리에 필요한 아이디어를 적극적으로 내는 사람인가", competency: "C", skill: "Creative thinking" },
            { id: 1003, text: "회원별 강점을 파악해 역할을 잘 분배할 수 있는 사람인가", competency: "M", skill: "Talent management" },
        ],
    },
    {
        id: 11,
        content: "학생들이 직접 리뷰를 올리고 공유할 수 있는 학교 주변 맛집 지도 앱을 만들고 있어. 만들면서 너가 가장 중요하게 생각하는 부분은?",
        options: [
            { id: 1101, text: "\"사용자의 데이터를 확보하는 것이 중요해.”", competency: "T", skill: "AI/BigData" },
            { id: 1102, text: "\"다른 앱과 비교했을 때 우리만의 차별점이 있어야 해.”", competency: "C", skill: "Analytical thinking" },
            { id: 1103, text: "\"사용자가 많아져도 버틸 수 있는 튼튼한 구조가 중요해”", competency: "S", skill: "Resilience" },
        ],
    },
    {
        id: 12,
        content: "맛집 지도 앱을 공개한 첫날, 갑자기 여러 버그가 동시에 터졌어. 1시간 뒤면 점심시간이라 사용자가 몰려올 텐데, 너가 팀장이라면 어떤 방법이 최선이라 생각해?",
        options: [
            { id: 1201, text: "최대한 버그를 줄이기 위해 일단 빠르게 고칠 수 있는 버그부터 수정한다.", competency: "T", skill: "Technology literacy" },
            { id: 1202, text: "오래 걸리더라도 사용자들의 불평이 가장 많은 버그부터 순서대로 고친다.", competency: "W", skill: "Empathy/active listening" },
            { id: 1203, text: "시간이 없어도 먼저 전체 계획을 세우고, 팀원들을 각자 잘 맞는 파트에 배치한다.", competency: "M", skill: "Resource management" },
        ],
    },
    {
        id: 13,
        content: "우주항공국에서 화성 탐사팀을 꾸리고 있어. 너는 탐사 대원으로서 어떤 역할을 가장 맡고 싶어? 하고 싶은 순서대로 골라봐.",
        options: [
            { id: 1301, text: "탐사 데이터를 분석해 아무도 몰랐던 사실을 알아내는 역할", competency: "C", skill: "Analytical thinking" },
            { id: 1302, text: "일정, 식량, 예산을 계획해서 탐사가 차질 없이 돌아가게 하는 역할", competency: "M", skill: "Resource management" },
            { id: 1303, text: "지치거나 다투는 대원들의 이야기를 들어주고 분위기를 살리는 역할", competency: "W", skill: "Empathy/active listening" },
            { id: 1304, text: "로봇, 드론 같은 기술 장비를 직접 만들고 고쳐서 문제를 해결하는 역할", competency: "T", skill: "Tech Literacy" },
            { id: 1305, text: "탐사 지역에 가장 먼저 발을 디디며, 새로운 길을 찾아내는 역할", competency: "S", skill: "Resilience" },
            { id: 1306, text: "탐사가 왜 중요한지 사람들에게 알리고 더 나은 방법을 고민하는 역할", competency: "E", skill: "Service orientation" },
        ],
    },
];

export const CHARACTER_DATA = {
    ANALYTICAL_CREATIVITY: {
        name: "솔이 마을",
        eng: "Analytical Creativity",
        image: "/images/exhibition/village_soli.png",
        desc: "분석적 창의력",
    },
    EMPATHY_LEADERSHIP: {
        name: "콩이 마을",
        eng: "Empathy Leadership",
        image: "/images/exhibition/village_kongi.png",
        desc: "공감기반 통솔력",
    },
    SELF_DIRECTED_RESILIENCE: {
        name: "뚝이 마을",
        eng: "Self-directed Resilience",
        image: "/images/exhibition/village_ttuki.png",
        desc: "자기주도적 회복력",
    },
    STRATEGIC_OPERATIONS: {
        name: "토리 마을",
        eng: "Strategic Operations",
        image: "/images/exhibition/village_tori.png",
        desc: "전략적 운영력",
    },
    DIGITAL_DESIGN: {
        name: "하루 마을",
        eng: "Digital Design",
        image: "/images/exhibition/village_haru.png",
        desc: "디지털 설계력",
    },
    SUSTAINABLE_INFLUENCE: {
        name: "엘리 마을",
        eng: "Sustainable Influence",
        image: "/images/exhibition/village_ellie.png",
        desc: "지속가능한 영향력",
    },
};

// 역량별 대표 문항 매핑
export const REPRESENTATIVE_QUESTIONS: Record<string, number[]> = {
    W: [1, 2],
    C: [3, 4],
    S: [5, 6],
    M: [7, 8],
    E: [9, 10],
    T: [11, 12],
};

// 역량 약어와 FCType 매핑
export const COMPETENCY_MAPPING: Record<string, string> = {
    C: "ANALYTICAL_CREATIVITY",
    W: "EMPATHY_LEADERSHIP",
    S: "SELF_DIRECTED_RESILIENCE",
    M: "STRATEGIC_OPERATIONS",
    T: "DIGITAL_DESIGN",
    E: "SUSTAINABLE_INFLUENCE",
};

/** 요원 등록 카드(`/play`) 활동 지역 선택지. BE 는 문자열 그대로 저장한다. */
export const PLAY_REGION_OPTIONS = [
    "서울특별시", "부산광역시", "대구광역시", "인천광역시", "광주광역시", "대전광역시", "울산광역시",
    "세종특별자치시", "경기도", "강원특별자치도", "충청북도", "충청남도", "전북특별자치도", "전라남도",
    "경상북도", "경상남도", "제주특별자치도",
] as const;

/** 요원 등록 카드(`/play`) 학년 선택지. */
export const PLAY_GRADE_OPTIONS = [
    "초등 1학년", "초등 2학년", "초등 3학년", "초등 4학년", "초등 5학년", "초등 6학년",
    "중등 1학년", "중등 2학년", "중등 3학년",
    "고등 1학년", "고등 2학년", "고등 3학년",
] as const;

/** 요원 등록 카드(`/play1`) 개인정보 수집 동의 상세. 약관 본문이 코드에 있다(CMS 없음). */
export const PLAY_PRIVACY_NOTICE = {
    intro: "㈜코드하나는 체험하기 채점 및 리포트 분석을 위해 아래와 같이 개인정보를 수집·이용합니다.",
    rows: [
        { label: "수집 항목", text: "이름, 직업, 소속, 연락처, 이메일(선택)" },
        { label: "수집 목적", text: "해봄 체험 결과 분석 및 서비스 안내" },
        { label: "보유 및 이용기간", text: "수집일로부터 2년 또는 동의 철회 시까지" },
        { label: "동의 거부 안내", text: "본 동의를 거부하실 수 있으나, 거부 시 해봄 체험 서비스 이용이 제한됩니다." },
    ],
} as const;

/**
 * 학생 요원 등록 카드(`/play3`, 14세 미만) 개인정보 수집 동의 상세. 학생 본인 정보만(실명·연락처 없음).
 * 법정대리인 이름·연락처는 마케팅 수신 동의(PLAY_CHILD_MARKETING_NOTICE) 쪽 항목이라 여기 넣지 않는다.
 */
export const PLAY_CHILD_PRIVACY_NOTICE = {
    intro: "㈜코드하나는 체험하기 채점 및 리포트 분석을 위해 아래와 같이 개인정보를 수집·이용합니다.",
    rows: [
        { label: "수집 항목", text: "지역, 성별, 학교, 학년, 닉네임(별명)" },
        { label: "수집 목적", text: "해봄 체험 결과 분석 및 서비스 안내" },
        { label: "보유 및 이용기간", text: "수집일로부터 2년 또는 동의 철회 시까지" },
        { label: "동의 거부 안내", text: "본 동의를 거부하실 수 있으나, 거부 시 해봄 체험 서비스 이용이 제한됩니다." },
    ],
} as const;

/**
 * 학생 요원 등록 카드(`/play3`, 14세 미만) 마케팅 수신 동의 상세. 대상은 학생이 아니라 법정대리인이고
 * 받는 정보도 법정대리인 이름·휴대전화뿐(이메일 없음). 2026-09-12 일반용(PLAY_MARKETING_NOTICE)과 분리.
 */
export const PLAY_CHILD_MARKETING_NOTICE = {
    intro: "㈜코드하나는 법정대리인께 교육 프로그램·행사·이벤트를 안내하기 위해 아래와 같이 개인정보를 활용합니다. 이 항목은 법정대리인이 확인하고 체크해 주세요.",
    rows: [
        { label: "이용 항목", text: "법정대리인 이름, 휴대전화 번호" },
        { label: "이용 목적", text: "신규 프로그램, 행사, 이벤트 안내 및 홍보(문자·전화)" },
        { label: "보유 기간", text: "수집일로부터 2년 또는 동의 철회 시까지" },
        { label: "동의 거부 안내", text: "법정대리인은 동의를 거부할 수 있으며, 동의하지 않아도 체험 이용에는 제한이 없습니다." },
    ],
} as const;

/** 요원 등록 카드(`/play1`) 마케팅 수신 동의 상세. */
export const PLAY_MARKETING_NOTICE = {
    intro: "㈜코드하나는 교육 프로그램, 행사, 이벤트 안내를 위해 아래와 같이 개인정보를 활용합니다.",
    rows: [
        { label: "이용 항목", text: "이름, 연락처, 이메일" },
        { label: "이용 목적", text: "신규 프로그램, 행사, 이벤트 안내 및 홍보" },
        { label: "보유 기간", text: "수집일로부터 2년 또는 동의 철회 시까지" },
        { label: "동의 거부 안내", text: "귀하는 마케팅 정보 수신에 대한 동의를 거부할 수 있으며, 동의하지 않아도 서비스 이용에는 제한이 없습니다. 동의 거부 시 수집된 정보는 해봄 체험하기 채점 및 분석으로만 활용됩니다." },
    ],
} as const;
